import { render, staticRenderFns } from "./RoundActionButton.vue?vue&type=template&id=58e540fa&scoped=true&"
import script from "./RoundActionButton.vue?vue&type=script&lang=js&"
export * from "./RoundActionButton.vue?vue&type=script&lang=js&"
import style0 from "./RoundActionButton.vue?vue&type=style&index=0&id=58e540fa&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58e540fa",
  null
  
)

export default component.exports